export default __webpack_public_path__ + "static/media/sound4.837027a8.mp3";